<div
    *ngIf="!hideBackdrop"
    class="avi-cinematic-portal__backdrop"
></div>
<ng-template
    class="clr-wrapper"
    #cinematicsContainer
></ng-template>
